/* eslint-disable radix */
import {
  concat, find, findIndex, insert, merge, pathOr, propEq, reject
} from 'ramda';

import Utils from 'src/utils';
import { addNewActionsToEmployee } from 'src/store/reducers/tools/employees';
import {
  DELETE_USER_CARD_FAIL,
  DELETE_USER_CARD_REQUEST,
  DELETE_USER_CARD_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_JOB_FAIL,
  DELETE_USER_JOB_REQUEST,
  DELETE_USER_JOB_SUCCESS,
  DELETE_USER_JOBS_MULTIPLE_SUCCESS,
  DELETE_USER_PHOTO_FAIL,
  DELETE_USER_PHOTO_REQUEST,
  DELETE_USER_PHOTO_SUCCESS,
  DELETE_USER_REQUEST,
  DELETE_USER_SKILL_SUCCESS,
  DELETE_USER_SUCCESS,
  HIDE_USER_CARD_INFO,
  LOAD_ALL_EMPLOYEES_FAIL,
  LOAD_ALL_EMPLOYEES_REQUEST,
  LOAD_ALL_EMPLOYEES_SUCCESS,
  LOAD_ALL_FULL_INFO_EMPLOYEES_FAIL,
  LOAD_ALL_FULL_INFO_EMPLOYEES_REQUEST,
  LOAD_ALL_FULL_INFO_EMPLOYEES_SUCCESS,
  LOAD_CARD_TYPES_FAIL,
  LOAD_CARD_TYPES_REQUEST,
  LOAD_CARD_TYPES_SUCCESS,
  LOAD_CONTRACT_TYPE_FAIL,
  LOAD_CONTRACT_TYPE_OPTIONS_SUCCESS,
  LOAD_CONTRACT_TYPE_REQUEST,
  LOAD_CONTRACT_TYPE_SUCCESS,
  LOAD_EMPLOYEES_FAIL,
  LOAD_EMPLOYEES_REQUEST,
  LOAD_EMPLOYEES_SUCCESS,
  LOAD_USER_INFO_FAIL,
  LOAD_USER_INFO_REQUEST,
  LOAD_USER_INFO_SUCCESS,
  LOAD_WORK_GROUP_FAIL,
  LOAD_WORK_GROUP_REQUEST,
  OPTIONS_SUCCESS,
  POST_USER_CARD_FAIL,
  POST_USER_CARD_REQUEST,
  POST_USER_CARD_SUCCESS,
  POST_USER_FAIL,
  POST_USER_JOB_FAIL,
  POST_USER_JOB_REQUEST,
  POST_USER_JOB_SUCCESS,
  POST_USER_JOBS_MULTIPLE_SUCCESS,
  POST_USER_REQUEST,
  POST_USER_SKILL_SUCCESS,
  POST_USER_SUCCESS,
  PUT_USER_BACK_FROM_ARCHIVE_SUCCESS,
  PUT_USER_FAIL,
  PUT_USER_JOB_FAIL,
  PUT_USER_JOB_REQUEST,
  PUT_USER_JOB_SUCCESS,
  PUT_USER_REQUEST,
  PUT_USER_SKILL_SUCCESS,
  PUT_USER_SUCCESS,
  RESET_EMPLOYEE_DATA,
  RESET_USER_INFO,
  SHOW_USER_CARD_INFO
} from 'src/store/actions/employeesActions';

import {
  CREATE_TIME_RATE_FAIL,
  CREATE_TIME_RATE_REQUEST,
  CREATE_TIME_RATE_SUCCESS,
  DELETE_TIME_RATE_FAIL,
  DELETE_TIME_RATE_REQUEST,
  DELETE_TIME_RATE_SUCCESS,
  LOAD_TIME_RATE_FAIL,
  LOAD_TIME_RATE_REQUEST,
  LOAD_TIME_RATE_SUCCESS,
  UPDATE_TIME_RATE_FAIL,
  UPDATE_TIME_RATE_REQUEST,
  UPDATE_TIME_RATE_SUCCESS
} from 'src/store/actions/timeRateAssociationsActions';

const initialState = {
  list: [], // includes both IsDeleted and !IsDeleted
  fullInfoList: [],
  fetching: false,
  errors: [],
  allEmployees: [],
  userInfo: {},
  userInfoFetching: false,
  timeRateFetching: 0,
  contractType: [],
  contractTypeFetching: false,
  contractOptions: [],
  cardTypes: [],
  options: [],
  filter: '',
  newUser: true,
  cardInfo: { title: '', list: [], isOpen: false }
};

export const loadUserInfoRequest = (userId) => ({ type: LOAD_USER_INFO_REQUEST, userId });

export const selectAllEmployees = pathOr([], ['employees', 'allEmployees']);

const addOrReplaceInList = (department, prop, list) =>
  // concat([filter], reject(propEq(prop, filter[prop]), list)); // if it exists, then add it to the list but remove old value first.
  // eslint-disable-next-line implicit-arrow-linebreak
  insert(findIndex(propEq(prop, department[prop]), list), department, reject(propEq(prop, department[prop]), list));

const replaceUserInList = (list, user) => list.map((listUser) => {
  if (listUser.UserId === user.UserId) {
    return user;
  }
  return listUser;
});

const listToOptions = (list) => list.map(({
  FirstName, LastName, UserId, ExternalCode
}) => ({
  value: UserId.toString(),
  label: `${LastName} ${FirstName}`,
  externalCode: ExternalCode
}));

const employeesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TIME_RATE_REQUEST:
    case CREATE_TIME_RATE_REQUEST:
    case UPDATE_TIME_RATE_REQUEST:
    case DELETE_TIME_RATE_REQUEST:
      return merge(state, { timeRateFetching: state.timeRateFetching + 1 });
    case LOAD_TIME_RATE_FAIL:
    case CREATE_TIME_RATE_FAIL:
    case UPDATE_TIME_RATE_FAIL:
    case DELETE_TIME_RATE_FAIL:
      return merge(state, { errors: action.err, timeRateFetching: state.timeRateFetching - 1 });
    case LOAD_TIME_RATE_SUCCESS:
    case CREATE_TIME_RATE_SUCCESS:
    case UPDATE_TIME_RATE_SUCCESS:
    case DELETE_TIME_RATE_SUCCESS: {
      const { timeRateSystem } = action;
      return merge(state, {
        userInfo: {
          ...state.userInfo,
          timeRateSystem
        },
        timeRateFetching: state.timeRateFetching - 1
      });
    }
    case LOAD_ALL_EMPLOYEES_REQUEST:
    case DELETE_USER_CARD_REQUEST:
    case LOAD_EMPLOYEES_REQUEST:
    case DELETE_USER_PHOTO_REQUEST:
    case LOAD_WORK_GROUP_REQUEST:
    case LOAD_CARD_TYPES_REQUEST:
    case DELETE_USER_REQUEST:
    case LOAD_ALL_FULL_INFO_EMPLOYEES_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_CONTRACT_TYPE_REQUEST:
      return merge(state, { fetching: true, contractTypeFetching: true });
    case LOAD_EMPLOYEES_SUCCESS:
      return merge(state, {
        list: action.data,
        allEmployees: Utils.arrays.mergeWithNestedObjectsReplace(state.allEmployees || [], action.data || [], 'UserId'),
        fetching: false
      });
    case LOAD_ALL_FULL_INFO_EMPLOYEES_SUCCESS:
      return merge(state, {
        fullInfoList: Utils.arrays.mergeWithNestedObjectsReplace(state.fullInfoList || [], action.data || [], 'UserId'),
        fetching: false
      });
    case LOAD_EMPLOYEES_FAIL:
    case LOAD_ALL_EMPLOYEES_FAIL:
    case LOAD_ALL_FULL_INFO_EMPLOYEES_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case OPTIONS_SUCCESS:
      return merge(state, { options: action.employees }); // employees options
    case LOAD_ALL_EMPLOYEES_SUCCESS:
      return merge(state, { allEmployees: action.data, fetching: false });
    case LOAD_USER_INFO_REQUEST:
      return merge(state, { userInfoFetching: true });
    case LOAD_USER_INFO_FAIL:
      return merge(state, { errors: action.err, userInfoFetching: false });
    case LOAD_USER_INFO_SUCCESS: {
      const { data: newUser } = action;
      const { UserId } = newUser;
      const stateUser = find(propEq('UserId', UserId), state.allEmployees);
      const flags = pathOr({}, ['Flags'], stateUser);

      // Workaround for #11375; we need to keep user in list, it solved trough new flag wasImported; have to keep a flag
      const user = merge(newUser, {
        Flags: merge(newUser.Flags, flags)
      });

      return merge(state, {
        userInfo: user,
        userInfoFetching: false,
        newUser: false
      });
    }
    case RESET_USER_INFO:
      return merge(state, { userInfo: {} });
    case LOAD_CONTRACT_TYPE_FAIL:
      return merge(state, { errors: action.err, fetching: false, contractTypeFetching: false });
    case LOAD_CONTRACT_TYPE_SUCCESS:
      return merge(state, { contractType: action.data, fetching: false, contractTypeFetching: false });
    case LOAD_CONTRACT_TYPE_OPTIONS_SUCCESS:
      return merge(state, { contractOptions: action.data });
    case LOAD_WORK_GROUP_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case LOAD_CARD_TYPES_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case LOAD_CARD_TYPES_SUCCESS:
      return merge(state, { cardTypes: action.data, fetching: false });
    case POST_USER_JOB_REQUEST:
      return merge(state, { fetching: true });
    case POST_USER_JOB_SUCCESS:
      return merge(
        state,
        {
          userInfo: merge(state.userInfo, {
            UserJobs: concat(state.userInfo.UserJobs || [], [action.userJob])
          }),
          fetching: false,
          errors: []
        }
      );
    case POST_USER_SKILL_SUCCESS:
      return merge(
        state,
        {
          userInfo: merge(state.userInfo, {
            UserSkills: concat(state.userInfo.UserSkills || [], [action.skill])
          }),
          fetching: false,
          errors: []
        }
      );
    case PUT_USER_SKILL_SUCCESS:
      return merge(
        state,
        {
          userInfo: merge(state.userInfo, {
            UserSkills: state.userInfo.UserSkills.map((job) => (job.Id === action.skill.Id ? action.skill : job))
          }),
          fetching: false,
          errors: []
        }
      );
    case DELETE_USER_SKILL_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        userInfo: merge(state.userInfo, {
          UserSkills: reject(propEq('Id', action.skill.id), state.userInfo.UserSkills)
        })
      });
    case POST_USER_JOBS_MULTIPLE_SUCCESS:
      return merge(
        state,
        {
          ...addNewActionsToEmployee(state, action.userJobs),
          fetching: false,
          errors: []
        }
      );
    case POST_USER_JOB_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case PUT_USER_JOB_REQUEST:
      return merge(state, { fetching: true });
    case PUT_USER_JOB_SUCCESS:
      return merge(
        state,
        {
          userInfo: merge(state.userInfo, {
            UserJobs: state.userInfo.UserJobs.map((job) => (job.Id === action.userJob.Id ? action.userJob : job))
          }),
          fetching: false,
          errors: []
        }
      );
    case PUT_USER_JOB_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case DELETE_USER_JOB_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_USER_JOB_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_USER_JOB_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        userInfo: merge(state.userInfo, {
          UserJobs: reject(propEq('JobId', action.userJob.JobId), state.userInfo.UserJobs)
        })
      });
    case DELETE_USER_JOBS_MULTIPLE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        userInfo: merge(state.userInfo, {
          UserJobs: state.userInfo.UserJobs.filter(({ JobId }) => !action.userJobs.jobIds.includes(JobId))
        })
      });
    case POST_USER_CARD_REQUEST:
      return merge(state, { fetching: true });
    case POST_USER_CARD_SUCCESS:
      return merge(
        state,
        {
          userInfo: merge(state.userInfo, {
            UserCards: concat(state.userInfo.UserCards || [], [action.userCard])
          }),
          fetching: false,
          errors: []
        }
      );
    case POST_USER_CARD_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case DELETE_USER_CARD_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_USER_CARD_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        userInfo: merge(state.userInfo, {
          UserCards: reject(propEq('Id', action.userCard.id), state.userInfo.UserCards)
        })
      });
    case SHOW_USER_CARD_INFO:
      return merge(state, {
        cardInfo: { ...action.info, isOpen: true }
      });
    case HIDE_USER_CARD_INFO:
      return merge(state, {
        cardInfo: { ...state.cardInfo, isOpen: false }
      });
    case POST_USER_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case POST_USER_SUCCESS:
      return merge(state, {
        list: concat(state.list, [action.user]),
        fetching: false,
        errors: [],
        allEmployees: state.allEmployees.length ? concat(state.allEmployees, [action.user]) : [],
        options: state.options.length ? listToOptions(concat(state.allEmployees, [action.user])) : [],
        userInfo: action.user,
        newUser: false
      });
    case POST_USER_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case DELETE_USER_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_USER_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('UserId', action.userId), state.list),
        allEmployees: reject(propEq('UserId', action.userId), state.allEmployees),
        userInfo: {},
        newUser: true
      });
    case PUT_USER_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case PUT_USER_SUCCESS: {
      action.user.UserJobs = [...(state.allEmployees.find((emp) => emp.UserId === action.user.UserId)?.UserJobs || [])];
      return merge(state, {
        fetching: false,
        errors: [],
        allEmployees: state.allEmployees.length ? addOrReplaceInList(action.user, 'UserId', state.allEmployees) : [],
        list: state.list.length ? addOrReplaceInList(action.user, 'UserId', state.list) : [],
        options: state.options.length ? listToOptions(addOrReplaceInList(action.user, 'UserId', state.allEmployees)) : []
      });
    }
    case PUT_USER_BACK_FROM_ARCHIVE_SUCCESS: {
      const newList = replaceUserInList(state.list, action.user);
      const newAllEmployees = [...state.allEmployees, action.user];
      return merge(state, {
        fetching: false,
        errors: [],
        list: newList,
        allEmployees: state.allEmployees.length ? newAllEmployees : [],
        options: state.options.length ? listToOptions(newAllEmployees) : [],
        userInfo: action.user
      });
    }
    case DELETE_USER_PHOTO_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        userInfo: { ...state.userInfo, Photo: '' }
      });
    case PUT_USER_FAIL:
    case DELETE_USER_PHOTO_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case RESET_EMPLOYEE_DATA:
      return merge(state, initialState);
    default:
      return state;
  }
};

export default employeesReducer;
